import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import P1 from '@base/P1/P1';
import H1 from '@base/H1/H1';
import H3 from '@base/H3/H3';
import Paper from '@base/Paper/Paper';
import Image from '@base/Image';
import useWindowSize from '@hooks/useWindowSize';

const generousLeavesPolicy = 'careers/generousLeavesPolicy.svg';
const insuranceBenefits = 'careers/InsuranceBenefits.svg';
const mndAndBodyWellnes = 'careers/mndAndBodyWellnes.svg';
const learningAndDevelopment = 'careers/learningAndDevelopment.svg';

const Wrapper = styled(Paper)`
  grid-column: span 24;
  display: flex;
  flex-direction: column;
  padding: ${Spacings.SPACING_0B} 132px;
  padding-top: 125px;
  padding-bottom: 138px;
  align-items: center;
  background: var(--color-i-blue-6);
  text-align: center;
  ${mediaQuery.uptoTablet} {
    padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_4B};
  }
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_4B};
  }
`;

const TextWrapper = styled.div`
  margin-bottom: 90px;
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_10B};
  }
`;

const HeadLine = styled(H1)`
  font-size: 40px;
  line-height: 120%;
  margin-bottom: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_1B};
    font-size: ${Fonts.H4};
  }
`;
const HeadlineSubtext = styled(H3)`
  font-weight: ${Fonts.REGULAR};
  width: 707px;
  ${mediaQuery.uptoMobile} {
    width: 290px;
    font-size: ${Fonts.H6};
  }
`;

const IconsCardWrapper = styled.div`
  display: grid;
  grid-gap: 0 ${Spacings.SPACING_20B};
  grid-template-columns: 1fr 1fr;
  ${mediaQuery.uptoTablet} {
    grid-gap: 0;
    grid-row-gap: 30px;
  }
  ${mediaQuery.uptoMobile} {
    grid-gap: 0;
    grid-template-columns: 1fr;
  }
`;
const IconCardDiv = styled.div`
  display: flex;
  text-align: left;
  margin: ${Spacings.SPACING_8B} ${Spacings.SPACING_0B};
  width: 511px;

  ${mediaQuery.uptoTablet} {
    margin: ${Spacings.SPACING_0B};
    width: 42vw;
  }
  ${mediaQuery.uptoMobile} {
    margin: ${Spacings.SPACING_0B};
    margin-bottom: ${Spacings.SPACING_6B};
    width: 296px;
  }
`;
const ImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  margin-right: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    width: 48px;
    height: 48px;
  }
`;
const IconCardHeadline = styled(H3)`
  margin-bottom: ${Spacings.SPACING_2B};
  line-height: 125%;

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H5};
    font-weight: ${Fonts.SEMIBOLD};
    margin-bottom: ${Spacings.SPACING_1B};
  }
`;
const IconCardSubText = styled(P1)`
  width: 415px;
  font-size: ${Fonts.H5};

  ${mediaQuery.uptoTablet} {
    font-size: ${Fonts.H6};
    width: 250px;
  }
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H6};
    width: 232px;
  }
`;
const iconsLink = [
  {
    id: 'icon-1',
    headline: 'Employee-friendly policies ',
    subText:
      'Maternity Leave | Paternity Leave | Adoption Leave | Period Leave | Creche Support',
    link: generousLeavesPolicy
  },
  {
    id: 'icon-2',
    headline: 'We’ve got your back',
    subText:
      'Insurance Cover for you and your family | National Pension Scheme | Flexible Benefit Plan | COVID-19 Insurance, leaves, and reimbursement',
    link: insuranceBenefits
  },
  {
    id: 'icon-3',
    headline: '360 degree wellness ',
    subText:
      'Exclusive partnership with Practo, Ultrahuman and 1 to 1 Help | Monthly wellness programmes | Game Zone | Open Pantry',
    link: mndAndBodyWellnes
  },
  {
    id: 'icon-4',
    headline: 'Unparalleled learning opportunities ',
    subText:
      'Competitive compensation | Best-in-class Mentors and Leaders | Accelerated growth | Timely reviews and feedbacks',
    link: learningAndDevelopment
  }
];

const IconCard = ({ data }) => {
  const { isMobile } = useWindowSize();
  return (
    <IconCardDiv>
      <ImageWrapper>
        <Image
          src={data.link}
          width={isMobile ? 48 : 80}
          height={isMobile ? 48 : 80}
          alt={data.headline}
        />
      </ImageWrapper>
      <div>
        <IconCardHeadline>{data.headline}</IconCardHeadline>
        <IconCardSubText>{data.subText}</IconCardSubText>
      </div>
    </IconCardDiv>
  );
};
const WhyUnacademy = () => {
  return (
    <Wrapper>
      <TextWrapper>
        <HeadLine>Why Unacademy?</HeadLine>
        <HeadlineSubtext>
          We believe in fostering a holistic and dynamic workplace where you can
          create, innovate and thrive!
        </HeadlineSubtext>
      </TextWrapper>
      <IconsCardWrapper>
        {iconsLink.map((icon) => (
          <IconCard data={icon} key={icon.id} />
        ))}
      </IconsCardWrapper>
    </Wrapper>
  );
};

export default WhyUnacademy;
